// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const PROD_URL = "https://cxtuyntqsbcgbtbzujof.supabase.co";
const PROD_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImN4dHV5bnRxc2JjZ2J0Ynp1am9mIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjU2ODI5MjIsImV4cCI6MjA4MTI1ODkyMn0.1OaqJhIO7Y8Dz6MIq90RBAJkF34avJOW3ERGQ9O3V_E";

// E2E staging override: only active when built/served with VITE_E2E=true.
const E2E = import.meta.env.VITE_E2E === 'true';
const SUPABASE_URL = E2E && import.meta.env.VITE_STAGING_SUPABASE_URL
  ? (import.meta.env.VITE_STAGING_SUPABASE_URL as string)
  : PROD_URL;
const SUPABASE_PUBLISHABLE_KEY = E2E && import.meta.env.VITE_STAGING_SUPABASE_ANON_KEY
  ? (import.meta.env.VITE_STAGING_SUPABASE_ANON_KEY as string)
  : PROD_KEY;

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});